<div fxLayout="row column" fxLayoutGap="20px" fxLayoutAlign="start">

  <div fxFlex>

    <app-product></app-product>

  </div>
  
  <div fxFlexx>

    <app-product-list></app-product-list>

  </div>


</div>

<router-outlet></router-outlet>